import { render, staticRenderFns } from "./Military.vue?vue&type=template&id=912cae94&scoped=true&"
import script from "./Military.vue?vue&type=script&lang=js&"
export * from "./Military.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912cae94",
  null
  
)

export default component.exports